<template>
    <div>
		<div class="changeMain">
			<el-card class="box-card">
				<div class="searchBox">
					<div class="page-filter-box">
					    <el-input placeholder="输入演出ID查询迁出演出" v-model="sActivityIds">
					        <el-button slot="append" icon="el-icon-search" @click="searchActivity(1)">查询门票</el-button>
					    </el-input>
						<div class="PD10" v-if="sActivityList && sActivityList[0]">
							演出ID: {{sActivityList[0].activityId}}
							<p class="MT10">演出名称: {{sActivityList[0].title}}</p>
						</div>
						<div class="MT15">
							<el-select v-model="params.userId" placeholder="请选择" size="small" v-if="sActivityList && sActivityList.length > 0"  @change="changeTicket">
								<el-option label="请选择票品" value=""></el-option>
								<el-option v-for="(item, index) in sActivityList" :key="index" :label="item.name" :value="item.ticketId" v-if="item.details !=''"></el-option>
							</el-select>
						</div>
						<el-table class="MT10" size="mini" border stripe v-loading="sActivityLoading" :data="detailsArrayLeft">							
							<el-table-column prop="id" label="订单和票数">
								<template slot-scope="scope">
									票数为{{scope.row.id}}的订单数:{{scope.row.name}}
								</template>
							</el-table-column>
							<el-table-column label="迁出的数量" width="150">
								<template slot-scope="scope">
								<el-input-number style="width:100%" v-model="scope.row.accountLimitNum" :precision="0" controls-position="right" :min="0" :max="scope.row.num" size="medium" placeholder="请填写迁出的数量" @change="changNum()"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-card>
			<div class="separate-box">
			    <div>
			        <i class="el-icon-arrow-right icon"></i>
			    </div>                    
			</div> 
			<el-card class="box-card">
				<div class="searchBox">
					<div class="page-filter-box">
					    <el-input placeholder="输入演出ID查询迁入演出" v-model="sActivityIds2">
					        <el-button slot="append" icon="el-icon-search" @click="searchActivity(2)">查询门票</el-button>
					    </el-input>						
						<div class="PD10" v-if="sActivityList2 && sActivityList2[0]">
							演出ID: {{sActivityList2[0].activityId}}
							<p class="MT10">演出名称: {{sActivityList2[0].title}}</p>
						</div>
						<div class="MT15">
							<el-select v-model="params2.userId" placeholder="请选择" size="small" v-if="sActivityList2 && sActivityList2.length > 0">
								<el-option label="请选择票品" value=""></el-option>
								<el-option v-for="(item, index) in sActivityList2" :key="index" :label="item.name" :value="item.ticketId"></el-option>
							</el-select>
						</div>
						<!-- <el-table class="MT10" size="mini" border stripe v-loading="sActivityLoading2" :data="detailsArrayRight">							
							<el-table-column prop="id" label="订单和票数">
								<template slot-scope="scope">
									票数为{{scope.row.id}}的订单数:{{scope.row.num}}
								</template>
							</el-table-column>
							<el-table-column label="迁出的数量" width="150">
								<template slot-scope="scope">
								<el-input-number style="width:100%" v-model="scope.row.accountLimitNum" :precision="0" controls-position="right" :min="0" :max="scope.row.num" size="medium" placeholder="请填写迁出的数量"></el-input-number>
								</template>
							</el-table-column>
						</el-table> -->
						<div class="PD10" v-if="leftTotal > 0">迁入总票数:{{leftTotal}}</div>
					</div>
				</div>
			</el-card>				       
		</div>
		<div class="MT20">
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/activity/ticketMove')" type="primary" @click="onSubmit" :loading="btnLoading" >确认迁移</el-button>
		</div>
    </div>
</template>
<script>
export default {
	props: {
	    id: {
	        type: [Number, String],
	        default: () => null
	    }
	},
    data() {
        return {
			params:{
			   userId:''
			},
			params2:{
			   userId:''
			},
			sActivityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			detailsArrayLeft:[],
			
			sActivityIds2: "",
			sActivityLoading2: false,
			sActivityList2: [],			
			detailsArrayRight:[],
			accountLimitNum:'',
			
			btnLoading:false,
			leftTotal:'',
			
        };
    },
   
    methods: {
		//返回
		goBack() {
			if(this.redirect){
				this.$router.push({
					path: this.redirect,
				});
			}else{
				this.$router.go(-1);
			}
		},
		//搜索演出
		searchActivity(type) {
			var _sActivityIds = ''
			if( type == 1 ){
				this.sActivityLoading = true;
				_sActivityIds = this.sActivityIds
				this.params.userId = ''
				this.detailsArrayLeft = []
			}
			if( type == 2 ){
				this.sActivityLoading2 = true;
				_sActivityIds = this.sActivityIds2
				this.params2.userId = ''
				this.detailsArrayRight = []
			}
			if( _sActivityIds == ''){
				if( type == 1 ){
					this.sActivityLoading = false;
				}
				if( type == 2 ){
					this.sActivityLoading2 = false;
				}
				return this.$message.error('演出ID不能为空');				
			}
			this.$request({
				url: '/activity/ticketInfo',
				method: 'post',
				params: {activityId:_sActivityIds}
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						
						if (result && result.length > 0 && type == 1) {
							
							this.sActivityList = result
							
						} else if( result && result.length > 0 && type == 2 ){
							this.sActivityList2  = result
							
						}else {
							this.$message.error(msg || '没有找到相关演出');
						}
						
						
					} else {
						this.$message.error(msg || "没有找到相关演出,请重试");
					}
				})
				.catch(() => {
					this.$message.error("没有找到相关演出,请重试");
				})
				.finally(() => {
					if( type == 1 ){
						this.sActivityLoading = false;
					}
					if( type == 2 ){
						this.sActivityLoading2 = false;
					}
				});
		},
		changeTicket(e){
			var detailsArray = []
			this.sActivityList.forEach((tab, idx) => {										
				tab.details.map((item,index) => {
					if( tab.ticketId === e ){
						detailsArray.push({
							id: item.id,
							name: item.name,
							num:item.id * parseInt(item.name),
							accountLimitNum:0
						})
					}
					
				})
			})
			this.detailsArrayLeft = detailsArray
			
		},
		
		changNum(){			
			var total = 0;
			for(let i = 0;i < this.detailsArrayLeft.length;i++){
				total += this.detailsArrayLeft[i].accountLimitNum * this.detailsArrayLeft[i].id;
			}			
			this.leftTotal = total
			
		},
		onSubmit(){
			var _details = []
			if( this.sActivityList && this.sActivityList.length == 0 || this.detailsArrayLeft && this.detailsArrayLeft.length == 0  || this.params.userId == ''){
				return this.$message.error("请选择需要迁出的门票");
			}else{				
				this.detailsArrayLeft.map( (item,index) => {				    
				    _details.push({
				        id: item.id,
				        name: item.accountLimitNum
				    })
				})				
			}
						
			if( this.leftTotal == 0 ){
				return this.$message.error("迁出门票数量不能为0");
			}
			if( this.sActivityList2 && this.sActivityList2.length == 0  || this.params2.userId == ''){
				return this.$message.error("请选择需要迁入的门票");
			}
			
			
			this.$confirm('是否确认迁移？', '门票迁移', {			    
			    center: false,
			    confirmButtonText:'确认迁移',
			    cancelButtonText:'取消',
			    closeOnClickModal: false
			}).then(() => {
			    this.btnLoading = true;
			    this.$request({
			        url: "/activity/ticketMove",
			        method: "post",
			        data: {
			    		activityId: this.sActivityList[0].activityId,
			    		newActivityId: this.sActivityList2[0].activityId,
			    		newTicketPriceId:this.params2.userId,
			    		ticketPriceId:this.params.userId,
			    		details:_details
			    	},
			    })
			        .then((res) => {
			            //处理成功回调
			            const { state, msg } = res.data;
			            if (state && state == 1) {
			                this.$message.success('迁移完成，请到演出详情页检查迁移结果是否正确');
			                
			            } else {
			                return this.$message.error(msg || "迁移失败");
			            }
			        })
			        .finally(() => {
			            this.btnLoading = false;
			        });
			}).catch(() => {										
			   // window.location.reload()
			})
			
		},
		
    }
};
</script>
<style lang="scss" scoped>
.el-alert__icon.is-big{
	width: 16px !important;
	height: 16px !important;
}
.changeMain{
	margin-top: 20px;
	display: flex;
	justify-content: space-between;
	.box-card{
		width: 48%;
		
	}
}
.separate-box{
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	div{
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background: #ccc;
	}
	.icon{
		font-size: 20px;
		color: #fff;
	}
}
.container{
    &>li{
		height: 100%;
		overflow: hidden;
		clear: both;
        margin-bottom: 10px;
        .el-button{
            padding: 0;
        }
		div{
			float: left;			
		}
		.red{			
			color: #f00;
		}
        div:first-child{
			float: left;
            margin-right: 10px;
            width: 120px;
            min-width: 140px;
            text-align: right;
            color: $--color-info;
        }
       
        &:nth-last-child(1){
            margin: 0;
        }
		&.tel{
			font-size: 16rpx;
			color: #f00;
		}
        .activityP{
			display: block;
			width: 100%;
			margin: 5px 0;
			
		}
    }    
}
</style>